
<div class="wrap-text">
  {{ invoice.number }} | {{ invoice.issueDate }} | {{ invoice.client }}
</div>
